import { HTMLAttributes } from 'react'
import styled, { DefaultTheme } from 'styled-components'

import {
  TResponsiveProps,
  TResponsiveVisibilityProps,
  responsiveStyle,
  responsiveVisibility,
} from '@hozana/styling/responsive'

const responsiveProps = { m: 'margin', w: 'width', h: 'height' } as const

export type TSeparatorProps = {
  noPrint?: boolean
  color?: keyof DefaultTheme['colors']
} & TResponsiveProps<typeof responsiveProps> &
  TResponsiveVisibilityProps &
  HTMLAttributes<HTMLDivElement>

export const Separator = styled.div<TSeparatorProps>`
  ${({ h = '1px', ...otherProps }) => responsiveStyle(responsiveProps)({ h, ...otherProps })}
  background-color: ${({ color, theme }) => (color ? theme.colors[color] : theme.colors.black10)};
  ${responsiveVisibility}

  /* Print */
  ${({ noPrint }) => noPrint && '@media print {display: none}'}
`
